import {
  EXECUTAR_VALIDACAO_INIT_IQVIA,
  EXECUTAR_VALIDACAO_SUCCESS_IQVIA,
  EXECUTAR_VALIDACAO_ERROR_IQVIA,
  CLEAR_FLAGS_VALIDACAO_IQVIA,
  CLEAR_DADOS_VALIDACAO_IQVIA,
  BUSCA_CONSULTAS_SUCCESS_IQVIA,
  BUSCA_CONSULTAS_INIT_IQVIA
} from '../actionTypes';

export const executarValidacaoInitIqvia = (data) => ({
  type: EXECUTAR_VALIDACAO_INIT_IQVIA,
  payload: data
});

export const executarValidacaoSuccessIqvia = (data) => ({
  type: EXECUTAR_VALIDACAO_SUCCESS_IQVIA,
  payload: data
});

export const buscaConsultasInitIqvia = (data) => ({
  type: BUSCA_CONSULTAS_INIT_IQVIA,
  payload: data
});

export const buscaConsultasSuccessIqvia = (data) => ({
  type: BUSCA_CONSULTAS_SUCCESS_IQVIA,
  payload: data
});

export const requestErrorValidacaoIqvia = (message) => ({
  type: EXECUTAR_VALIDACAO_ERROR_IQVIA,
  payload: message
});

export const clearFlagsValidacaoIqvia = () => ({
  type: CLEAR_FLAGS_VALIDACAO_IQVIA
});

export const clearDadosValidacaoIqvia = () => ({
  type: CLEAR_DADOS_VALIDACAO_IQVIA
});
